/* External dependencies */
import { ofType } from 'redux-observable';
import { from, Observable } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

/* Local dependencies */
import { initClient } from '../../../../clients/client';
import { cognitoSignOut } from '../../../../clients/cognito';
import { confirmRegistration, sendVerificationCode } from '../../../../clients/custom-auth';
import { loginFailed } from '../login/redux/actions';
import {
  confirmRegistrationFailed,
  confirmRegistrationSuccess,
  initClientFailed,
  initClientSucceeded,
  logoutFailed,
} from '../redux/auth-actions';
import { AuthAction, AuthActionTypes, ConfirmRegistrationRequest, SendVerificationCodeRequest } from './types';

export function initClientEpic(action$: Observable<AuthAction>) {
  return action$.pipe(
    ofType(AuthActionTypes.INIT_CLIENT),
    switchMap(() => from(initClient()).pipe(catchError(() => from([initClientFailed()])))),
  );
}

export function sendVerificationCodeEpic(action$: Observable<AuthAction>) {
  return action$.pipe(
    ofType(AuthActionTypes.SEND_VERIFICATION_CODE_REQUEST),
    switchMap((action: SendVerificationCodeRequest) =>
      from(sendVerificationCode(action)).pipe(
        switchMap((result) => from([initClientSucceeded(result)])),
        catchError((error) => from([logoutFailed(error)])),
      ),
    ),
  );
}

export function logoutEpic(action$: Observable<AuthAction>) {
  return action$.pipe(
    ofType(AuthActionTypes.LOGOUT_REQUEST),
    switchMap(() => from(cognitoSignOut()).pipe(catchError((error) => from([loginFailed(error)])))),
  );
}

export function confirmRegistrationEpic(action$: Observable<AuthAction>) {
  return action$.pipe(
    ofType(AuthActionTypes.CONFIRM_REGISTRATION_REQUEST),
    switchMap((action: ConfirmRegistrationRequest) =>
      from(confirmRegistration(action)).pipe(
        switchMap(() => from([confirmRegistrationSuccess()])),
        catchError((error) => from([confirmRegistrationFailed(error)])),
      ),
    ),
  );
}
